import styled from "styled-components";

export const LandingPageWrapper = styled.main`
  background-color: #fff;
`;
